import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "top-border" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Restablecer contraseña", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Introduzca su e-mail y pulse \"Restablecer\". Se le enviará un correo con las instrucciones para restablecer su contraseña.", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "username-container" }, [
  /*#__PURE__*/_createElementVNode("label", null, "E-mail"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-input" }, [
    /*#__PURE__*/_createCommentVNode(" <InputText ref=\"emailControl\" placeholder=\"E-mail\" v-model=\"request.user.email\" />")
  ])
], -1 /* HOISTED */)
const _hoisted_8 = { class: "username-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Confirmar e-mail", -1 /* HOISTED */)
const _hoisted_10 = { class: "login-input" }
const _hoisted_11 = { class: "forgetpassword-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: $setup.getLogoUrl,
        style: {"width":"100px"}
      }, null, 8 /* PROPS */, _hoisted_4),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_InputText, {
            ref: "emailConfirmControl",
            placeholder: "Confirme su e-mail",
            modelValue: $setup.emailconfirm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.emailconfirm) = $event))
          }, null, 8 /* PROPS */, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", {
          href: "#",
          class: "forget-password",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:isForgetPassChild', false)))
        }, "Volver a la página de acceso.")
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          id: "submitButton",
          onClick: $setup.onSubmitForgotPassword,
          label: "Restablecer"
        }, null, 8 /* PROPS */, ["onClick"])
      ])
    ])
  ]))
}